import { createSlice } from "@reduxjs/toolkit";
import { contractManagerApi } from "queries/contractManagerApi";

// planAsAtTomorrow is used to check if there is a midnight plan change pending
const planAsAtTomorrowSlice = createSlice({
  name: "planChangeTomorrow",
  initialState: {
    planId: undefined,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(
        contractManagerApi.endpoints.getContracts.matchFulfilled,
        (state, { payload: contractAsAtTomorrow }) => {
          state.planId = contractAsAtTomorrow.id;
        },
      )
      .addMatcher(
        contractManagerApi.endpoints.updateCurrentPlan.matchFulfilled,
        (state, { payload }) => {
          state.planId = payload.planId;
        },
      );
  },
});

export const planAsAtTomorrowSliceReducer = planAsAtTomorrowSlice.reducer;
